import { connect } from 'react-redux';

import GmailView from './GmailView.jsx';
import { fetchIntegrations, getIntegrationForType } from 'src/legacy/redux/actions/integrations.jsx';
import { authenticateAccount } from 'src/legacy/redux/actions/emailIntegration.jsx';
import {trackAdoptionMetricsForPluginConnectedEvent} from "src/legacy/redux/actions/adoption";
import _ from 'lodash';
import withUseHooks from 'src/legacy/components/withUseHooks.jsx';

const mapStateToProps = (state, ownProps) => {
    let integration = getIntegrationForType(state, 'gmail');
    return {
        integration: integration,
        integrations: state.legacyRootReducer.settings.integrations,
        activating: state.legacyRootReducer.settings.integrations.email.activating,
        deactivating: state.legacyRootReducer.settings.integrations.activated.deactivating.loading,
        error: state.legacyRootReducer.settings.integrations.email.error,
        user: _.get(state, 'legacyRootReducer.users.me',""),
        integrationsLoading: _.get(state.legacyRootReducer.settings.integrations, 'activated.loading' ,false)
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        authenticateAccount: (code, type) => {
            return dispatch(authenticateAccount(code, type));
        },

        fetchIntegrations: () => {
            return dispatch(fetchIntegrations());
        },
        trackAdoptionMetricsForPluginConnectedEvent: (partnerName) =>{
            return dispatch(trackAdoptionMetricsForPluginConnectedEvent(partnerName))
        }
    }
}

const GmailPage = connect(
    mapStateToProps,
    mapDispatchToProps
)(GmailView);

export default withUseHooks(GmailPage);